import React from "react";
import "../style/description.css"; // Ensure the correct file extension

const Description = () => {
  return (
    <div className="description-text">
      {/* Fixed className */}
      <h3 className="desc-text">
        We specialize in delivering high-quality civil construction services
        tailored to your needs. Whether you're looking for premium, luxurious
        structures or budget-friendly yet durable solutions, we bring expertise,
        innovation, and reliability to every project.
      </h3>
    </div>
  );
};

export default Description;
